import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=35f1ea92&scoped=true"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=js"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordRequest.vue?vue&type=style&index=0&id=35f1ea92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1ea92",
  null
  
)

export default component.exports